<template>
    <div class="cta-caja cta-caja--lila" @click="clicking">
      <portal to="alerts_constructor_page" v-if="showProductAddedConfirmation">
      <div class="bb-alert bb-alert--success">
            <div class="bb-alert__ico">
              <i class="uil uil-check"></i>
            </div>
            <div class="bb-alert__left">
              <div class="bb-alert__content bb-alert__content--flex">
                ¡Objeto añadido a tu lista!
              </div>
              <router-link class="bb-alert__now" to="mi-lista">Revisa tu lista</router-link>
              <div class="bb-alert__close">
                <i class="uil uil-multiply" @click="showProductAddedConfirmation=false"></i>
              </div>
            </div>
          </div>
    </portal>
      <div class="cta-caja__cover">
        <img
          class="cta-caja__cover-desk"
          src="https://images.hellobb.net/robot-cocina-beaba-desktop.jpg"
          alt=""
        />
        <img
          class="cta-caja__cover-mobile"
          src="https://images.hellobb.net/robot-cocina-beaba-responsive.jpg"
          alt=""
        />
      </div>
      <div class="cta-caja__content">
        <h4 class="cta-caja__title">Robot de cocina Babycook Express de Béaba</h4>
        <div class="cta-caja__description">
          <p>Porque cualquier cosa que ahorre trabajo es bienvenida con un bebé.</p>
        </div>
        <div class="cta-caja__actions">
          <loading-button v-if="loading" :class="'button-loading--sm'" />
          <button
            v-else
            class="button button--accent button--sm button--ico"
            @click.stop="addProduct('Constructor - Banner Horitzontal')"
            :disabled="added"
          >
            {{ buttonText }}
          </button>
        </div>
      </div>
      <modal-dialog
          :show="showProductAddedDialog"
          @close="showProductAddedDialog = false"
          target-class="modal__card--mini"
      >
        <product-added-to-list/>
      </modal-dialog>
    </div>
  </template>
  
  <script>
  import Product from "./Mixins/Product";
  import LoadingButton from "../../../components/LoadingButton";
  import ModalDialog from "../../../components/ui/ModalDialog";
  import ProductAddedToList from "../../../components/ProductAddedToList";
  
  export default {
    name: "CtaRobot",
    mixins: [Product],
    data() {
      return {
        showProductAddedConfirmation: false,
      };
    },
    components: {
      LoadingButton,
      ModalDialog,
      ProductAddedToList
    },
    computed: {
      buttonText() {
        return this.added ? "Añadido" : "Añadir a mi lista";
      },
    },
    created() {
      this.product = {
        id: 42549,
        "brand-slug": "beaba",
        name: "Robot de cocina",
        retailerName: "HelloBB",
        productRetailers: [{"name": "HelloBB"}]
      };
    },
    methods: {
      clicking()
      {
        mixpanel.track("Click element constructor", {
          "Name": "Robot de cocina",
          "Section": "Los libros para bebés más adorables",
          "Section number": 1,
          "Type": "Banner - Horizontal",
          "Content": "Ecommerce"
        });
        this.browseProduct();
      }
    }
  };
  </script>